import {
    DEPOTS_LIST_RESPONCE,
    EDIT_DEPOTS_REDUX_STATE,
    DELETE_DEPOTS_REDUX_STATE,
    EDIT_DEPOTS_STATUS_REDUX_STATE

} from "./actionTypes";

const INIT_STATE = {
    depotsList: [],
};

/**
 * Reducer function for managing the state of depots.
 * @param {object} state - The current state of depots.
 * @param {object} action - The action object that contains the type and payload.
 * @returns The updated state of depots.
 */
const Depots = (state = INIT_STATE, action) => {
    switch (action.type) {

        case DEPOTS_LIST_RESPONCE:
           
            state = {
                ...state,
                depotsList: action.payload,
              }
              return state;
          case  EDIT_DEPOTS_REDUX_STATE:
            state = {
                ...state,
                depotsList:{data : action.payload},
                }
                return state;
         case  DELETE_DEPOTS_REDUX_STATE:
            state = {
                ...state,
                depotsList:{data :action.payload},
                }
                return state;
        case  EDIT_DEPOTS_STATUS_REDUX_STATE:
              state = {
                ...state,
                depotsList:{data : action.payload},
                  }
                return state;
              
        default:
            return state;
    }
};


export default Depots;